import axios from "axios";
import { smartsightAPI } from "../constants/defaultValues";

const API = axios.create({
  baseURL: smartsightAPI
});

// Add request interceptor for debugging
API.interceptors.request.use(
  (config) => {
    console.log("🚀 API Request:", {
      method: config.method?.toUpperCase(),
      url: config.url,
      baseURL: config.baseURL,
      fullURL: `${config.baseURL}${config.url}`,
      data: config.data,
      headers: config.headers
    });
    return config;
  },
  (error) => {
    console.error("❌ API Request Error:", error);
    return Promise.reject(error);
  }
);

export default API;
